var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "order-card-container"
  }, [[_c('b-card', {
    style: _vm.activatePaymentKey ? 'margin-top: 10px;' : '',
    attrs: {
      "header-class": "price-header",
      "header": _vm.$t('payment.priceDetails')
    }
  }, [_vm.$store.state['checkout'].checkoutLoading == true ? _vm._l(8, function (i) {
    return _c('b-skeleton', {
      key: i,
      staticClass: "mb-3",
      style: `width: ${Math.floor(Math.random() * 31) + 50}%;`,
      attrs: {
        "animation": "wave"
      }
    });
  }) : _vm._e(), _vm.$store.state['checkout'].checkoutLoading == false ? _c('blockquote', {
    staticClass: "blockquote mb-0"
  }, [_c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', [_c('b-card-text', {
    staticClass: "price-details"
  }, [_vm._v(_vm._s(_vm.$t("payment.subTotal")) + " "), _c('br'), _vm._v("(" + _vm._s(_vm.cartItemCount) + " " + _vm._s(_vm.$t("payment.items")) + ")")])], 1), _c('b-col', [_c('b-card-text', {
    staticClass: "float-right price-details"
  }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + _vm._s(Number(_vm.checkoutData.listPrice).toFixed(2)) + " " + _vm._s(_vm.currency.code))])], 1)], 1), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', [_c('b-card-text', {
    staticClass: "price-details color-red"
  }, [_vm._v(_vm._s(_vm.$t("payment.discount")) + ": ")])], 1), _c('b-col', [_c('b-card-text', {
    staticClass: "float-right price-details color-red"
  }, [_vm._v(" - "), _c('span', [_vm._v(" " + _vm._s(_vm.currency.symbol) + " " + _vm._s(Number(_vm.checkoutData.totalDiscount).toFixed(2)) + " " + _vm._s(_vm.currency.code))])])], 1)], 1), _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', [_c('b-card-text', {
    staticClass: "price-details"
  }, [_vm._v(_vm._s(_vm.$t("payment.tax")) + ":")])], 1), _c('b-col', [_c('b-card-text', {
    staticClass: "float-right price-details"
  }, [_vm._v(" " + _vm._s(Number(_vm.checkoutData.totalTaxes).toFixed(2)) + " " + _vm._s(_vm.currency.code) + " ")])], 1)], 1), !_vm.checkoutData.totalDeliveryCharge == 0 ? _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', [_c('b-card-text', {
    staticClass: "price-details"
  }, [_vm._v(_vm._s(_vm.$t("payment.shipping")) + ": ")])], 1), _c('b-col', [_c('b-card-text', {
    staticClass: "float-right price-details"
  }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + _vm._s(Number(_vm.checkoutData.totalDeliveryCharge).toFixed(2)) + " " + _vm._s(_vm.currency.code))])], 1)], 1) : _vm._e(), _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', [_c('b-card-text', {
    staticClass: "price-total-amount"
  }, [_vm._v(_vm._s(_vm.$t("payment.totalAmount")) + " ")])], 1), _c('b-col', [_c('b-card-text', {
    staticClass: "float-right price-total-amount"
  }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + _vm._s(Number(_vm.checkoutData.totalPrice).toFixed(2)) + " " + _vm._s(_vm.currency.code))])], 1)], 1)], 1) : _vm._e(), _vm.$options.components['address-no-address'] && _vm.$store.state['checkout'].checkoutLoading === 'errorAddress' ? [_c('address-no-address')] : _vm._e()], 2)]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }